export const DEFAULT_PROFILE_TAB = "overview";

export const PROFILE_TABS = [
    { id: "overview", label: "Overview" },
    { id: "matches", label: "Matches" },
    { id: "performance", label: "Performance" },
    { id: "reputation", label: "Reputation" },
    { id: "friends", label: "Friends" },
    { id: "loadout", label: "Loadout" },
];

export const PROFILE_TAB_IDS = PROFILE_TABS.map((tab) => tab.id);

export function getVisibleProfileTabs(canViewLoadout) {
    if (canViewLoadout) {
        return PROFILE_TABS;
    }
    return PROFILE_TABS.filter((tab) => tab.id !== "loadout");
}

const LEGACY_TAB_ALIASES = {
    summary: "overview",
    history: "matches",
    stats: "performance",
    friends: "friends",
    trust: "reputation",
};

export function resolveProfileTab(tabParam) {
    if (!tabParam) {
        return DEFAULT_PROFILE_TAB;
    }

    if (PROFILE_TAB_IDS.includes(tabParam)) {
        return tabParam;
    }

    return LEGACY_TAB_ALIASES[tabParam] || DEFAULT_PROFILE_TAB;
}

export function getProfileTabFromSearch(search) {
    const params = new URLSearchParams(search);
    return resolveProfileTab(params.get("tab"));
}

export function buildProfileTabSearch(currentSearch, tabId) {
    const params = new URLSearchParams(currentSearch);
    const resolvedTab = resolveProfileTab(tabId);
    params.set("tab", resolvedTab);
    return params.toString();
}
